
import { useState } from 'react';
import { SEO } from '../../utils/seo';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PricingTabs from './components/PricingTabs';
import SolarCalculator from './components/SolarCalculator';
import AgricultureCalculator from './components/AgricultureCalculator';
import RoofCalculator from './components/RoofCalculator';
import DeliverablesPanel from './components/DeliverablesPanel';
import CtaSection from './components/CtaSection';
import FaqSection from './components/FaqSection';

export default function PricingPage() {
  const [activeTab, setActiveTab] = useState<'solar' | 'agriculture' | 'roof'>('solar');

  return (
    <>
      <SEO
        title="Pricing | Drone Inspection Services"
        description="Estimate pricing for drone inspections using our calculator. Clear ranges, scalable pricing, fast turnaround, firm quotes available."
        keywords="drone inspection pricing, solar farm inspection cost, drone service rates, inspection calculator"
        canonical="https://greenfield-partners.com/pricing"
      />

      <div className="min-h-screen bg-white">
        <Header />
        
        <HeroSection />
        
        <section className="py-16 bg-stone-50">
          <div className="max-w-7xl mx-auto px-6">
            <PricingTabs activeTab={activeTab} onTabChange={setActiveTab} />
            
            <div className="mt-12">
              {activeTab === 'solar' && (
                <>
                  <SolarCalculator />
                  <DeliverablesPanel />
                </>
              )}
              
              {activeTab === 'agriculture' && (
                <AgricultureCalculator />
              )}
              
              {activeTab === 'roof' && (
                <RoofCalculator />
              )}
            </div>
          </div>
        </section>
        
        <CtaSection />
        
        <FaqSection />
        
        <Footer />
      </div>
    </>
  );
}
